import {Text} from "@pg-design/text-module";
import {themeRP as theme} from "@pg-design/themes";

export const UserDataAdministrator = () => {
    return (
        <Text align="center" color={theme.colors.gray[600]} variant="info_txt_3">
            Administratorem Twoich danych osobowych jest Property Group sp. z o.o.
        </Text>
    );
};
import {Text} from "@pg-design/text-module";
import {themeRP as theme} from "@pg-design/themes";

export const UserDataAdministrator = () => {
    return (
        <Text align="center" color={theme.colors.gray[600]} variant="info_txt_3">
            Administratorem Twoich danych osobowych jest Property Group sp. z o.o.
        </Text>
    );
};
